<div class="admin-container">
  <h2>{{pageTitle}}</h2>

  <div class="search-header">
    <!-- TABS -->
    <div class="tabs-container">
      <div class="tabs">
        <button (click)="changeAll()" class="tab" [class.active]="activeTab === 'all'">Todos
          <span class="count">({{totalTodosUsuarios}})</span>
        </button>
        <button (click)="changeNew()" class="tab" [class.active]="activeTab === 'new'">Nuevos
        </button>
      </div>
    </div>
    <!-- SEARCH BAR -->
    <div class="search-controls">
      <div class="search-container">
        <div class="search-box">
          <input type="text" [(ngModel)]="searchTerm" (input)="searchUsers()" placeholder="Buscar usuario" class="search-input">
          <button class="search-button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </button>
        </div>
      </div>
      <!-- BOTON CREAR -->
      <button (click)="newAccount()" class="btn-create">
        Crear nueva cuenta
      </button>
    </div>

  </div>


  <div class="table-container">
    <div class="loader" *ngIf="loading">Cargando...</div>

    <table *ngIf="!loading && users.length > 0">
      <thead>
        <tr>
          <th>Nombre y Apellido</th>
          <th>Correo</th>
          <th>Estado</th>
          <th>Fecha Ingreso</th>
          <th>Categoria Experto</th>
          <th>Publicado</th>
          <th>Citas</th>
          <th>Acción</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users">
          <td>{{ user.name }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.status.name }}</td>
          <td>{{ user.createdAt | date : "dd/MM/yyyy" }}</td>
          <td>
            <div *ngIf="getUserCategories(user).length > 0" style="display: flex; flex-direction: column; gap: 4px;">
              <span *ngFor="let category of getUserCategories(user)" 
                    style="display: inline-block; padding: 4px 8px; background-color: #f0f0f0; border-radius: 4px; font-size: 0.9em; margin-bottom: 2px;">
                {{ category.name }}
              </span>
            </div>
            <div *ngIf="getUserCategories(user).length === 0" style="color: #999; font-size: 0.9em;">
              Sin categorías seleccionadas
            </div>
          </td>
          <td>
            <span *ngIf="user.publicado !== undefined && user.publicado !== null">
              <span *ngIf="user.publicado" 
                    style="display: inline-block; padding: 4px 10px; background-color: #28a745; color: white; border-radius: 12px; font-size: 0.85em; font-weight: 500;">
                Publicado
              </span>
              <span *ngIf="!user.publicado" 
                    style="display: inline-block; padding: 4px 10px; background-color: #dc3545; color: white; border-radius: 12px; font-size: 0.85em; font-weight: 500;">
                No publicado
              </span>
            </span>
            <span *ngIf="user.publicado === undefined || user.publicado === null" 
                  style="display: inline-block; padding: 4px 10px; background-color: #6c757d; color: white; border-radius: 12px; font-size: 0.85em; font-weight: 500;">
              N/A
            </span>
          </td>
          <td>
            <div style="display: flex; gap: 8px; align-items: center;">
              <button (click)="viewExpertAppointments(user)" class="btn-view-appointments" title="Ver citas">
                <i class="fas fa-eye"></i>
              </button>
              <button (click)="downloadExpertAppointments(user)" class="btn-download-appointments" title="Descargar reporte de citas">
                <i class="fas fa-download"></i>
              </button>
            </div>
          </td>
          <td>
            <!-- <button (click)="editUser(user)" class="btn-edit">Editar</button> -->
            <button (click)="editarUsuario(user)" class="btn-editar">Editar</button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="empty-state" *ngIf="!loading && users.length === 0">
      No hay usuarios para mostrar
    </div>
  </div>

  <!-- MODAL CREAR USUARIO -->
  <div class="modal-overlay" *ngIf="showModalForm" (click)="closeModalForm()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{editMode ? 'Editar' : 'Agregar'}} experto</h2>
        <button class="close-button" (click)="closeModalForm()">×</button>
      </div>

      <div class="modal-body">
        <form [formGroup]="usuarioFormGroup" (ngSubmit)="guardarUsuario()" class="example-container">
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group" style="flex: 1 1 100%;">
              <label>Nombre completo*</label>
              <input type="text" class="" placeholder="Nombre completo" formControlName="FULLNAME">
              <div *ngIf="frmUsuario['FULLNAME'].invalid && (frmUsuario['FULLNAME'].dirty || frmUsuario['FULLNAME'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['FULLNAME'].hasError('required')">Nombre requerido</span>
              </div>
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <label>Correo</label>
              <input type="email" class="" placeholder="Email" formControlName="EMAIL">
              <div *ngIf="frmUsuario['EMAIL'].invalid && (frmUsuario['EMAIL'].dirty || frmUsuario['EMAIL'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['EMAIL'].hasError('required')">Correo requerido</span>
                <span class="text-danger" *ngIf="frmUsuario['EMAIL'].hasError('email')">Correo no válido</span>
              </div>
            </div>

            <div class="form-group">
              <label>Celular*</label>
              <input type="number" class="" style="width: 19%;margin-right: 2px;" placeholder="Code" formControlName="CODETELEFONO">
              <input type="number" class="" style="width: 80%;" placeholder="Celular" formControlName="TELEFONO">
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <label>Fecha de Ingreso</label>
              <input type="date" class="" formControlName="FECHAINGRESO">
              <div *ngIf="frmUsuario['FECHAINGRESO'].invalid && (frmUsuario['FECHAINGRESO'].dirty || frmUsuario['FECHAINGRESO'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['FECHAINGRESO'].hasError('required')">Fecha requerida</span>
              </div>
            </div>

            <div class="form-group">
              <label>Categorías*</label>
              <select 
                formControlName="CATEGORIASEXPERTO" 
                multiple
                size="5"
                style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">
                <option *ngFor="let item of expertCategories" [value]="item.id.toString()">
                  {{item.name}}
                </option>
              </select>
              <small style="color: #666; font-size: 0.85em; display: block; margin-top: 5px;">
                Mantén presionada la tecla Ctrl (o Cmd en Mac) para seleccionar múltiples categorías
              </small>
              <div *ngIf="frmUsuario['CATEGORIASEXPERTO'].invalid && (frmUsuario['CATEGORIASEXPERTO'].dirty || frmUsuario['CATEGORIASEXPERTO'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['CATEGORIASEXPERTO'].hasError('required')">Debe seleccionar al menos una categoría</span>
              </div>
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <label>Costo por hora (S/)*</label>
              <input type="number" class="" placeholder="Ej: 250" formControlName="COST" min="0" step="0.01">
              <div *ngIf="frmUsuario['COST'].invalid && (frmUsuario['COST'].dirty || frmUsuario['COST'].touched)">
                <span class="text-danger" *ngIf="frmUsuario['COST'].hasError('required')">Costo por hora requerido</span>
                <span class="text-danger" *ngIf="frmUsuario['COST'].hasError('min')">El costo debe ser mayor a 0</span>
              </div>
            </div>

            <div class="form-group">
              <label>Estado de publicación</label>
              <div style="display: flex; align-items: center; gap: 12px; margin-top: 8px;">
                <label style="display: flex; align-items: center; gap: 6px; cursor: pointer; font-weight: normal;">
                  <input 
                    type="checkbox" 
                    formControlName="PUBLICADO"
                    style="width: 18px; height: 18px; cursor: pointer;">
                  <span>Publicado</span>
                </label>
                <span style="color: #999;">|</span>
                <span style="color: #666; font-size: 0.9em;">
                  {{ frmUsuario['PUBLICADO'].value ? 'Publicado' : 'No publicado' }}
                </span>
              </div>
            </div>
          </div>
          <!-- FILA -->
          <div class="form-row">
            <div class="form-group">
              <button type="button" class="btn-cancel" (click)="closeModalForm()">Cancelar</button>
            </div>

            <div class="form-group">
              <button type="submit" class="btn-save" [disabled]="usuarioFormGroup.invalid">Guardar</button>
            </div>
          </div>

        </form>
      </div>

      <div class="modal-footer">
        <!-- <button class="cancel-button" (click)="closeModalForm()">Cerrar</button> -->
      </div>
    </div>
  </div>

  <!-- MODAL VER CITAS DEL EXPERTO -->
  <div class="modal-overlay" *ngIf="showAppointmentsModal" (click)="closeAppointmentsModal()">
    <div class="modal-content appointments-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Citas de {{ selectedExpert?.name }}</h2>
        <button class="close-button" (click)="closeAppointmentsModal()">×</button>
      </div>

      <div class="modal-body">
        <div class="loading-appointments" *ngIf="loadingAppointments">
          <p>Cargando citas...</p>
        </div>

        <div class="appointments-list" *ngIf="!loadingAppointments">
          <div *ngIf="expertAppointments.length === 0" class="no-appointments">
            <p>No hay citas registradas para este experto.</p>
          </div>

          <div *ngIf="expertAppointments.length > 0" class="appointments-container">
            <div class="appointment-item" *ngFor="let appointment of expertAppointments">
              <div class="appointment-header">
                <div class="appointment-date-time">
                  <span class="appointment-date">
                    <i class="fas fa-calendar"></i>
                    {{ appointment.date | date: 'dd/MM/yyyy' }}
                  </span>
                  <span class="appointment-time">
                    <i class="fas fa-clock"></i>
                    {{ appointment.time }}
                  </span>
                </div>
                <span class="appointment-status" [class.completed]="isAppointmentCompleted(appointment)" [class.pending]="!isAppointmentCompleted(appointment)">
                  {{ isAppointmentCompleted(appointment) ? 'Realizada' : 'Pendiente' }}
                </span>
              </div>
              
              <div class="appointment-details">
                <div class="detail-row" *ngIf="appointment.customer">
                  <strong>Cliente:</strong> {{ appointment.customer.name }}
                </div>
                <div class="detail-row" *ngIf="appointment.duration">
                  <strong>Duración:</strong> {{ appointment.duration }} minutos
                </div>
              </div>

              <div class="appointment-notes" *ngIf="appointment.notes">
                <strong>Notas:</strong>
                <div class="notes-content" [innerHTML]="appointment.notes"></div>
              </div>

              <div class="appointment-notes" *ngIf="!appointment.notes">
                <em>Sin notas registradas</em>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-close-modal" (click)="closeAppointmentsModal()">Cerrar</button>
      </div>
    </div>
  </div>

</div>